var map = {
	"./barndoor.jpg": 76,
	"./barndoor2.jpg": 77,
	"./barndoor3.jpg": 78,
	"./barndoor4.jpg": 79,
	"./blacktable.jpg": 80,
	"./blacktable2.jpg": 81,
	"./blacktable3.jpg": 82,
	"./blacktable4.jpg": 23,
	"./blacktable5.jpg": 83,
	"./kitchen.jpg": 20,
	"./planters.jpg": 21,
	"./shoerack.jpg": 22,
	"./tvDoors.jpg": 24,
	"./tvDoors2.jpg": 84,
	"./vanityCupboards.jpg": 85,
	"./whitetable.jpg": 86,
	"./whitetable2.jpg": 87,
	"./woodTopDesk.jpg": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;